import { useState, type FormEvent } from "react";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type Fideicomiso } from "@/lib/api";
import { validarNombreDesarrollo } from "@/lib/fideicomisos";

/** Alta de un desarrollo (sin JSX): sólo el nombre; el resto se completa en Configuración → Fideicomiso. */
export function useNuevoDesarrollo(alCrear: (creado: Fideicomiso) => Promise<void> | void) {
  const [nombre, setNombre] = useState("");
  const [intentado, setIntentado] = useState(false);
  const accion = useAsyncAction(async (n: string) => {
    const creado = await api.post<Fideicomiso>("/api/fideicomisos", { nombre: n });
    await alCrear(creado);
    return creado;
  });
  const errorNombre = validarNombreDesarrollo(nombre);

  const crear = async (e: FormEvent) => {
    e.preventDefault();
    setIntentado(true);
    if (errorNombre) return;
    await accion.run(nombre.trim());
  };

  return {
    nombre,
    cambiarNombre: setNombre,
    errorNombre: intentado ? errorNombre : null,
    crear,
    creando: accion.loading,
    error: accion.error,
  };
}
